import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class ShiftPatternReferenceService extends BaseReferenceService {
  constructor() {
    super('ShiftPatternReference');
  }
}
